import React from 'react';
import { Link } from 'react-router-dom';
import LottieAnimation from '../assets/Animations/Lottie';
import animationData from '../assets/Animations/sleeping-404.json';
import { Button } from '@material-ui/core';



class NotFound extends React.Component {
    render(){
        return (
                 <div className='mainAnimation'> 
                    <div style={{"textAlign": "center", "padding": "80px"}}>
                        <Link to="/photos" style={{"textDecoration": "none"}}>
                            <Button variant="outlined" color="primary">Go to Home</Button>
                        </Link>
                    </div>
                    <LottieAnimation lotti={animationData} height={300} width={300} />
                </div>       
        );
    }
}


export default NotFound;